<!--订单统计-->
<template>
    <el-dialog
        :title="msg('统计')"
        :visible.sync="visible"
        :close-on-click-modal="false"
        width="300">
        <el-form ref="form" label-width="100px">
            <el-form-item :label="msg('选中数量：')">
                <el-tag size="medium" type="primary">{{checked}}</el-tag> 条
            </el-form-item>
            <el-form-item :label="msg('对应订单：')">
                <el-tag size="medium" type="primary">{{count}}</el-tag> 个
            </el-form-item>
            <el-form-item :label="msg('商品件数：')">
                <el-tag size="medium" type="primary">{{qty}}</el-tag> 件
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="toggleVisible">{{msg('确定')}}</el-button>
        </span>
    </el-dialog>
</template>
<script>

export default {
    name: 'SummaryDetail',
    data(){
        return {
            checked: 0, //选中数量
            count:0, //对应订单
            qty:0, //商品件数
            visible: false,
        }
    },
    methods: {
        toggleVisible() {
            this.visible = !this.visible
        },
        doSummary(selectes){
            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                this.checked= 0; //选中数量
                this.count=0; //对应订单
                this.qty=0;//商品件数
                this.visible = false;
                return;
            }
            let qty = 0;
            let stockArr = [];
            selectes.forEach(e=>{
                
                let productQty = e.productQty || (e.detail && e.detail.productQty);

                if(productQty && productQty > 0){
                    qty += productQty;
                }
                stockArr.push(e.stockId*1);
            })
            let stockNums = Array.from(new Set(stockArr));
            this.checked=selectes.length;
            this.count=stockNums.length;
            this.qty=qty;
            this.visible=true; 
        }
    }
}
</script>